import React, { useEffect } from 'react';

import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import Layout from 'components/layout';
import { theme } from 'components/layout/brand-theme';
import ReduceProviders from 'components/reduce-providers';
import { brand, isKiosk, isLocalDev, platform } from 'utils/environment';
import { LaunchDarklyFlagsObject } from 'utils/launchdarkly';
import LocalStorage from 'utils/local-storage';
import { Keys } from 'utils/local-storage/constants';

import providers from './providers';
import Global from './styles/global';

const clearStorageOnBrandChange = () => {
  const prevBrand = LocalStorage.getItem(Keys.BRAND);
  if (prevBrand && brand() !== prevBrand) {
    LocalStorage.clearAll();
  }
  LocalStorage.setItem(Keys.BRAND, brand());
};

if (!isKiosk) {
  const shouldClear = !LocalStorage.isCurrentVersion();
  if (isLocalDev) {
    clearStorageOnBrandChange();
  }

  // NOTE: cypress-v2 test suite requirement
  // Avoid localStorage clearing. Cypress does this automatically between tests.
  if (shouldClear && !window.Cypress) {
    LocalStorage.clearAll();
    LocalStorage.setCurrentVersion();
  }
}

export default function App({ ldFlags }: { ldFlags: LaunchDarklyFlagsObject }) {
  const [BRAND, PLATFORM] = [brand().toUpperCase(), platform()];

  useEffect(() => {
    if (!isLocalDev) {
      const renderSuccessTime = performance.now?.();
      const durationTillRenderSuccess = renderSuccessTime - window.LOADING_START_TIME;
      (window.dataLayer || []).push({
        event: 'APP_REACT_RENDER_SUCCESS',
        brand: BRAND,
        timestamp: renderSuccessTime,
        duration: durationTillRenderSuccess,
        platform: PLATFORM
      });
    }
  }, [BRAND, PLATFORM]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <Router>
          <Global />
          <ReduceProviders providers={providers(ldFlags)}>
            <Layout />
          </ReduceProviders>
        </Router>
      </ThemeProvider>
    </>
  );
}
